import React,{useState} from 'react';
import "./index.scss";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";
function launchGalary(_i, changeCurrentIndex, changeGalOpen){
  changeCurrentIndex(_i);
  changeGalOpen(true);
}
function App() {
  let [galopen, changeGalOpen]           = useState(false);
  let [singOpen, changeSing]             = useState(false);
  let [currentIndex, changeCurrentIndex] = useState(0);
  let images = [
    {
      url: "img/1.jpg",
      title: "Photo by Benjamin Voros"
    },
    {
      url: "img/2.jpg",
      title: "Photo by Jerry Zhang"
    },
    {
      url: "img/3.jpg",
      title: "Photo by Kalen Emsley"
    },
    {
      url: "img/4.jpg",
      title: "Photo by Rohit Tandon"
    }
  ]
  return (
    <div className="App">
      <div className="title">Example with a single Image. Navigation will be hidden</div>
      <div className="single-opener-holder">
        <div className="single-example" onClick={e=>changeSing(true)}>Open Single Image Example</div>
      </div>
      <div className="title">Example with multiple images. Navigation will be shown</div>
    <div className="gal">
      {images.map((_im,idx)=><img key={_im.url} src={_im.url} alt={_im.title} onClick={e=>launchGalary(idx,changeCurrentIndex, changeGalOpen)}/>)}
    </div>
      {galopen?<Lightbox startIndex={currentIndex} images={images} onClose={e=>changeGalOpen(false)}/>:null}
      {singOpen?<Lightbox image="img/1.jpg" title="Photo by Benjamin Voros" onClose={e=>changeSing(false)}/>:null}
    </div>
  );
}

export default App;
